import type { PlanTypes } from '@gonfalon/billing/types';

import { planIdToPlan } from './planData';

/**
 * Check if a plan is a Foundation-tier plan (requires payment card UI).
 * Foundation-tier plans include: Foundation2023, Foundation2025, and legacy Developer (which maps to Foundation2023).
 * Falls back to false if plan is not found (for legacy plans without metadata).
 */
export const isFoundationPlan = (planType: PlanTypes): boolean => {
  // Find the plan in planData by matching planType
  const plan = Object.values(planIdToPlan).find((p) => p.planType === planType);

  // If plan is found, use its isFoundationPlan property
  // Otherwise, assume it's not a Foundation plan (legacy behavior)
  return plan?.isFoundationPlan ?? false;
};
